import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class ParagraphIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 40 40"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<rect width="40" height="40"
					  style={{
						  fill: this.props.color,
						  fillOpacity: 0.5,
						  fillRule: "evenodd",
						  stroke: "#000000",
						  strokeWidth: 1,
						  strokeMiterlimit: 4,
						  strokeOpacity: 1,
						  strokeDasharray: "none"
					  }}/>
				<path
					d="m 17.692678,34.50206 0,-16.182224 c -1.930515,-0.103225 -3.455824,-0.730383 -4.57593,-1.881473 -1.12011,-1.151067 -1.680164,-2.619596 -1.680164,-4.405591 0,-1.992435 0.621995,-3.5796849 1.865988,-4.7617553 1.243989,-1.1820288 3.06352,-1.7730536 5.458598,-1.7730764 l 9.802246,0 0,2.6789711 -2.229895,0 0,26.3251486 -2.632515,0 0,-26.3251486 -3.45324,0 0,26.3251486 z"
					style={{
						fontSize: "29.42051125px",
						fontStyle: "normal",
						fontVariant: "normal",
						fontWeight: "normal",
						fontStretch: "normal",
						textAlign: "start",
						lineHeight: "125%",
						letterSpacing: 0,
						wordSpacing: 0,
						writingMode: "horizontal-tb",
						textAnchor: "start",
						fill: "#ffffff",
						fillOpacity: 1,
						stroke: "#000000",
						strokeWidth: 1.07795751,
						strokeOpacity: 1,
						fontFamily: "Arial"
					}}/>
			</svg>
		);
	}
}